module.exports = __webpack_public_path__ + "media/flags/011-brazil-27b1ebc0.svg";